import React from "react";
import classNames from "classnames";
import { UseCases } from "@planzone/core";

import { QuickCreationMenuWrapper } from "@common/quickCreationMenuWrapper";
import { useModal } from "@root/client/modal";
import { Elements, Props } from "./types";
import { Task } from "./task";
import { Event } from "./event";
import { ToggleArrow } from "./toggleArrow";
import { Milestone } from "./milestone";
import styles from "./styles.scss";
import { project } from "@planzone/dto";

function List({ list, isOpen: open, depth = 0 }: Props) {
  const [isOpen, setIsOpen] = React.useState(open !== undefined ? open : true);
  const { pushView } = useModal();
  const elementsNumber = list.elementsNumber;
  const elements = [
    ...list.subLists.map((element) => ({
      type: Elements.LIST,
      data: { ...element, rank: element.activityKeyRank },
    })),
    ...list.tasks.map((element) => ({
      type: Elements.TASK,
      data: { ...element, rank: element.activityKeyRank },
    })),
    ...list.milestones.map((element) => ({
      type: Elements.MILESTONE,
      data: { ...element, rank: element.keyRank },
    })),
    ...list.events.map((element) => ({
      type: Elements.EVENT,
      data: { ...element, rank: element.keyRank },
    })),
  ];
  return (
    <div className={styles.list}>
      <div className={styles.heading}>
        <QuickCreationMenuWrapper
          project={project}
          parentList={list}
          isInactive
          isThick
        >
          <div className={styles.headingWrapper}>
            <div className={styles.iconBox} onClick={() => setIsOpen(!isOpen)}>
              <ToggleArrow
                className={classNames(styles.icon, {
                  [styles.openedIcon]: isOpen,
                })}
              />
            </div>
            <h3
              className={styles.name}
              onClick={() =>
                pushView({
                  key: UseCases.retrieveList,
                  data: { listId: list.uuid },
                })
              }
            >
              {list.name}{" "}
              <span className={styles.elementsNbr}>{elementsNumber}</span>
            </h3>
            <div className={styles.contextualMenu} />
          </div>
        </QuickCreationMenuWrapper>
      </div>
      {isOpen && (
        <div
          className={classNames(styles.main, {
            [styles.empty]: isOpen,
          })}
        >
          {elements.length > 0 &&
            elements.map((element, index) => (
              <div key={element.data.uuid} className={styles.element}>
                {element.type === Elements.LIST ? (
                  <div className={styles.lists}>
                    <List
                      key={element.data.uuid}
                      list={element.data as any}
                      depth={depth + 1}
                    />
                  </div>
                ) : element.type === Elements.TASK ? (
                  <React.Fragment>
                    <QuickCreationMenuWrapper
                      project={project}
                      parentList={list}
                    >
                      <div>
                        <Task
                          task={element.data as any}
                          project={project}
                          list={list}
                        />
                      </div>
                    </QuickCreationMenuWrapper>
                  </React.Fragment>
                ) : element.type === Elements.EVENT ? (
                  <React.Fragment>
                    <QuickCreationMenuWrapper
                      project={project}
                      parentList={list}
                    >
                      <div>
                        <Event
                          event={element.data as any}
                          list={list}
                          project={project}
                        />
                      </div>
                    </QuickCreationMenuWrapper>
                  </React.Fragment>
                ) : (
                  element.type === Elements.MILESTONE && (
                    <React.Fragment>
                      <QuickCreationMenuWrapper
                        project={project}
                        parentList={list}
                      >
                        <div>
                          <Milestone
                            milestone={element.data as any}
                            project={project}
                          />
                        </div>
                      </QuickCreationMenuWrapper>
                    </React.Fragment>
                  )
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

export { List };
